export const FILTER_CONFIG = {
    "groups": [
        {
            "key": "TRADES",
            "label": "Trades",
            "subgroups": [
                {
                    "key": "DEFAULT",
                    "label": "",
                    "filters": [
                        {
                            "id": "PRIMARY_TRADE",
                            "label": "Primary Trade",
                            "filterType": "DROP_DOWN",
                            "advanced": false,
                            "preview": false,
                            "keepOpen": true,
                            "schemaProperty": "company_class_primary_trade",
                            "optionsSchemaProperty": "company_class_trades",
                            "insight": {
                                "title": "INSIGHT - How it Works",
                                "text": "Trades are inferred from keyword analysis across multiple data sources, supported by machine learning and human review. This classification is designed for accuracy but may not always be correct."
                            }
                        },
                        {
                            "id": "SECONDARY_TRADES",
                            "label": "Trades",
                            "filterType": "DROP_DOWN",
                            "advanced": false,
                            "preview": false,
                            "operatorOverride": "contains",
                            "schemaProperty": "company_class_trades",
                            "optionsSchemaProperty": "company_class_trades",
                            "keepOpen": true
                        },
                        {
                            "id": "ANY_ASSIGNED_TRADE",
                            "label": "Any Assigned Trade",
                            "filterType": "HAS_VALUE",
                            "advanced": false,
                            "preview": false,
                            "schemaProperty": "company_class_trades"
                        },
                        {
                            "id": "INCLUDE_CONTRACTORS_WITHOUT_A_TRADE",
                            "label": "Include Contractors without a Trade",
                            "filterType": "HAS_VALUE",
                            "advanced": true,
                            "preview": false,
                            "infoText": "AI Can Make Mistakes (density)",
                            "schemaProperty": "company_class_trades",
                            "operatorOverride": "notSet",
                            "insight": {
                                "title": "INSIGHT - How it Works",
                                "text": "Not all contractors in the system have been assigned a trade. This option will ensure they do not 'fall off' if a selection is made above."
                            }
                        },
                        {
                            "id": "NAICS",
                            "label": "NAICS",
                            "filterType": "DROP_DOWN",
                            "operatorOverride": "contains",
                            "advanced": true,
                            "preview": false,
                            "schemaProperty": "company_class_naics_titles_formatted",
                            "optionsSchemaProperty": "company_class_naics_descriptions",
                            "keepOpen": true
                        },
                        {
                            "id": "SIC",
                            "label": "SIC",
                            "filterType": "DROP_DOWN",
                            "operatorOverride": "contains",
                            "advanced": true,
                            "preview": false,
                            "schemaProperty": "company_class_sic_titles_formatted",
                            "optionsSchemaProperty": "company_class_sic_descriptions",
                            "keepOpen": true
                        }
                    ]
                }
            ]
        },
        {
            "key": "TERRITORY",
            "label": "Territory",
            "subgroups": [
                {
                    "key": "LOCATION",
                    "label": "Location",
                    "filters": [
                        {
                            "id": "STATE",
                            "label": "State",
                            "filterType": "DROP_DOWN",
                            "advanced": false,
                            "preview": false,
                            "keepOpen": true,
                            "schemaProperty": "company_address_region"
                        },
                        {
                            "id": "MSA",
                            "label": "MSA",
                            "filterType": "DROP_DOWN",
                            "advanced": false,
                            "preview": false,
                            "keepOpen": true,
                            "schemaProperty": "company_address_loc_msa"
                        },
                        // {
                        //     "id": "TERRITORY_RESIDENTIAL_DELIVERY_INDICATOR",
                        //     "label": "Residential Delivery Indicator",
                        //     "filterType": "DROP_DOWN",
                        //     "advanced": false,
                        //     "preview": false,
                        //     "infoText": "Residential Delivery Indicator or RDI is a USPS provided flag that associates the address to a Residential or Commercial building type. This can be an indicator of the size and maturity of a contractor.",
                        //     "schemaProperty": "company_address_rdi"
                        // },
                        {
                            "id": "CITY",
                            "label": "City",
                            "filterType": "CONTAINS",
                            "advanced": true,
                            "preview": false,
                            "schemaProperty": "company_address_city"
                        },
                        {
                            "id": "POSTAL_CODE",
                            "label": "Postal Code",
                            "filterType": "DROP_DOWN",
                            "allowNew": true,
                            "keepOpen": true,
                            "advanced": true,
                            "preview": false,
                            "schemaProperty": "company_address_postal_code"
                        }
                    ]
                },
                {
                    "key": "AUTHORIZATION_&_ACTIVITY",
                    "label": "Authorization & Activity",
                    "filters": [
                        {
                            "id": "LICENSED_IN",
                            "label": "Licensed In",
                            "filterType": "DROP_DOWN",
                            "advanced": false,
                            "preview": false,
                            "keepOpen": true,
                            "infoText": "States where the contractor is licensed to work",
                            "schemaProperty": "company_license_regions"
                        },
                        {
                            "id": "LICENSED_BY",
                            "label": "Licensed By",
                            "filterType": "DROP_DOWN",
                            "advanced": false,
                            "preview": false,
                            "keepOpen": true,
                            "infoText": "The licensing authority associated to a contractors license",
                            "schemaProperty": "company_license_source_labels"
                        },
                        {
                            // NOT A FILTER (spec TCU 2026.02.0): this checkbox does not
                            // emit a cube clause of its own. When on, CubeFilterBuilder
                            // re-scopes LICENSED_IN -> company_license_active_license_regions
                            // and LICENSED_BY -> company_license_active_license_source_labels.
                            // The schemaProperty below is a registry placeholder only and is
                            // never sent to cube (see TERRITORY_ALO_FIELD_SWAP).
                            "id": "TERRITORY_ACTIVE_LICENSES_ONLY",
                            "label": "Active Licenses Only",
                            "filterType": "HAS_VALUE",
                            "advanced": false,
                            "preview": false,
                            "insight": {
                                "title": "INSIGHT - How it Works",
                                "text": "We track active and inactive licenses for our contractors. By default we do not limit based on the status of the license. This option will ensure only contractors with active licenses are included if a selection is made above."
                            },
                            "schemaProperty": "active_licenses_only"
                        },
                        {
                            "id": "PERMITS_PULLED_IN_STATE",
                            "label": "Permits Pulled In (State)",
                            "filterType": "DROP_DOWN",
                            "advanced": false,
                            "preview": false,
                            "keepOpen": true,
                            "infoText": "States where the contractor has performed permitted work",
                            "schemaProperty": "company_permit_regions"
                        },
                        // {
                        //     "id": "PERMITS_PULLED_IN_MSA",
                        //     "label": "Permits Pulled In (MSA)",
                        //     "filterType": "DROP_DOWN",
                        //     "advanced": false,
                        //     "preview": false,
                        //     "infoText": "MSAs where the contractor has performed permitted work",
                        //     "schemaProperty": "company_permit_msas" //company_permit_msas
                        // }
                    ]
                }
            ]
        },
        {
            "key": "SERVICES",
            "label": "Services",
            "subgroups": [
                {
                    "key": "CAPABILITIES",
                    "label": "Capabilities",
                    "filters": [
                        {
                            "id": "MARKETS",
                            "label": "Markets",
                            "filterType": "DROP_DOWN",
                            "advanced": true,
                            "preview": false,
                            "keepOpen": true,
                            "schemaProperty": "company_ind_markets"
                        },
                        {
                            "id": "SERVICES_OFFERRED",
                            "label": "Services Offerred",
                            "filterType": "DROP_DOWN",
                            "advanced": false,
                            "preview": false,
                            "keepOpen": true,
                            "schemaProperty": "company_services"
                        },
                        // {
                        //     "id": "PROJECT_TYPES",
                        //     "label": "Project Types",
                        //     "filterType": "DROP_DOWN",
                        //     "advanced": false,
                        //     "preview": true,
                        //     "infoText": "We're working on refining this attribute. It's currently based on projects worked exclusively by Buildertrend Builders and General Contractors. We're actively working on modeling out the right project type definitions and scaling those to the entire Contractor Universe",
                        //     "schemaProperty": "company_activity_job_project_types" //company_activity_job_project_types
                        // },
                        {
                            "id": "WORK_SCOPE",
                            "label": "Work Scope",
                            "filterType": "DROP_DOWN",
                            "advanced": false,
                            "preview": false,
                            "keepOpen": true,
                            "schemaProperty": "company_ind_work_scopes"
                        },
                    ]
                },
                {
                    "key": "BRAND_RELATIONSHIPS",
                    "label": "Brand Relationships",
                    "filters": [
                        {
                            "id": "BRAND_AFFINITY_TYPES",
                            "label": "Brand Affinity Types",
                            "filterType": "DROP_DOWN",
                            "advanced": false,
                            "preview": false,
                            "keepOpen": true,
                            "insight": {
                                "title": "INSIGHT - How it Works",
                                "text": "Brand relationships are inferred from multiple data sources, including manufacturer and contractor websites, certified dealer listings, industry associations, and project or permit details. These associations are designed for accuracy but may not always be complete or current."
                            },
                            "schemaProperty": "company_affinities_brand_types"
                        },
                        {
                            "id": "BRAND_AFFINITIES",
                            "label": "Brand Affinities",
                            "filterType": "DROP_DOWN",
                            "advanced": false,
                            "preview": false,
                            "keepOpen": true,
                            "schemaProperty": "company_affinities_brands"
                        },
                        {
                            "id": "CERTIFIED_DEALER",
                            "label": "Certified Dealer",
                            "filterType": "HAS_VALUE",
                            "advanced": true,
                            "preview": false,
                            "schemaProperty": "company_affinities_is_certified_dealer"
                        },
                        {
                            "id": "CERTIFICATION_TYPE",
                            "label": "Certification Type",
                            "filterType": "DROP_DOWN",
                            "advanced": true,
                            "preview": false,
                            "keepOpen": true,
                            "schemaProperty": "company_affinities_certified_dealer_types"
                        },
                        {
                            "id": "CERTIFICATION_DEALER_OF",
                            "label": "Certified Dealer of",
                            "filterType": "DROP_DOWN",
                            "advanced": true,
                            "preview": false,
                            "keepOpen": true,
                            "schemaProperty": "company_affinities_certified_dealer_of"
                        }
                    ]
                }
            ]
        },
        {
            "key": "PROFILE",
            "label": "Profile",
            "subgroups": [
                {
                    "key": "OVERVIEW",
                    "label": "Overview",
                    "filters": [
                        {
                            "id": "NAME",
                            "label": "Name",
                            "filterType": "CONTAINS",
                            "advanced": false,
                            "preview": false,
                            "schemaProperty": "company_name"
                        },
                        {
                            "id": "DOMAIN",
                            "label": "Domain (Website)",
                            "filterType": "CONTAINS",
                            "advanced": false,
                            "preview": false,
                            "schemaProperty": "company_url_domain"
                        },
                        {
                            "id": "HAS_WEBSITE",
                            "label": "Has Website",
                            "filterType": "HAS_VALUE",
                            "advanced": false,
                            "preview": false,
                            "schemaProperty": "company_has_url"
                        }
                    ]
                },
                {
                    "key": "REACHABILITY",
                    "label": "Reachability",
                    "filters": [
                        {
                            "id": "PROFILE_HAS_PHONE",
                            "label": "Has Phone",
                            "filterType": "HAS_VALUE",
                            "advanced": false,
                            "preview": false,
                            "schemaProperty": "ux_filter_profile_has_phone"
                        },
                        {
                            "id": "PROFILE_HAS_EMAIL",
                            "label": "Has Email",
                            "filterType": "HAS_VALUE",
                            "advanced": false,
                            "preview": false,
                            "schemaProperty": "ux_filter_profile_has_email"
                        },
                        {
                            "id": "PROFILE_EMAIL_VERIFIED",
                            "label": "Email Verified",
                            "filterType": "HAS_VALUE",
                            "advanced": false,
                            "preview": false,
                            "schemaProperty": "ux_filter_profile_has_verified_email",
                            "insight": {
                                "title": "INSIGHT - How it Works",
                                "text": "We search across company and contact details to determine reachability. Email verification is performed by 3rd party services."
                            }
                        },
                        {
                            "id": "EMAIL_STATUS",
                            "label": "Email Status",
                            "filterType": "DROP_DOWN",
                            "advanced": true,
                            "preview": false,
                            "keepOpen": true,
                            "schemaProperty": "ux_filter_profile_email_status"
                        }
                    ]
                },
                {
                    "key": "BASICS",
                    "label": "Basics",
                    "filters": [
                        {
                            "id": "OPERATING_STATUS",
                            "label": "Operating Status",
                            "filterType": "DROP_DOWN",
                            "advanced": false,
                            "preview": false,
                            "keepOpen": true,
                            "schemaProperty": "company_registration_local_registration_status_mapped",
                            "optionsSchemaProperty": "company_reg_local_registration_status"
                        },
                        {
                            "id": "BUSINESS_STRUCTURE",
                            "label": "Business Structure",
                            "filterType": "DROP_DOWN",
                            "advanced": false,
                            "preview": false,
                            "keepOpen": true,
                            "schemaProperty": "company_fact_business_structure"
                        },
                        {
                            "id": "PUBLIC_OR_PRIVATE",
                            "label": "Public or Private",
                            "filterType": "DROP_DOWN",
                            "advanced": false,
                            "preview": false,
                            "keepOpen": true,
                            "schemaProperty": "company_fact_public_private"
                        },
                        {
                            "id": "OWNERSHIP_DESIGNATION",
                            "label": "Ownership Designation",
                            "filterType": "DROP_DOWN",
                            "advanced": false,
                            "preview": false,
                            "keepOpen": true,
                            "schemaProperty": "company_fact_ownership_types"
                        },
                        {
                            "id": "YEAR_FOUNDED",
                            "label": "Year Founded",
                            "filterType": "CONTAINS",
                            "advanced": true,
                            "preview": false,
                            "schemaProperty": "company_fact_founded"
                        }
                    ]
                },
                {
                    "key": "AFFILIATIONS",
                    "label": "Affiliations",
                    "filters": [
                        {
                            "id": "ASSOCIATION_MEMBER",
                            "label": "Association Member",
                            "filterType": "HAS_VALUE",
                            "advanced": false,
                            "preview": false,
                            "schemaProperty": "company_affinities_associations"
                        },
                        // {
                        //     "id": "ASSOCIATION_TYPE",
                        //     "label": "Association Type",
                        //     "filterType": "DROP_DOWN",
                        //     "advanced": false,
                        //     "preview": false,
                        //     "schemaProperty": "company_affiliation_types",
                        // },
                        {
                            "id": "ASSOCIATIONS",
                            "label": "Associations",
                            "filterType": "DROP_DOWN",
                            "advanced": true,
                            "preview": false,
                            "keepOpen": true,
                            "schemaProperty": "company_profile_association_profiles"
                        },
                        {
                            "id": "ASSOCIATION_SEARCH",
                            "label": "Association Search",
                            "filterType": "CONTAINS",
                            "advanced": true,
                            "preview": false,
                            "schemaProperty": "company_affinities_associations"
                        }
                    ]
                },
                {
                    "key": "PRESENCE",
                    "label": "Presence",
                    "filters": [
                        {
                            "id": "ONLINE_PRESENCE",
                            "label": "Online Presence",
                            "filterType": "HAS_VALUE",
                            "advanced": false,
                            "preview": false,
                            "schemaProperty": "company_profile_online_profiles"
                        },
                        {
                            "id": "ONLINE_PLATFORM_TYPES",
                            "label": "Online Platform Types",
                            "filterType": "DROP_DOWN",
                            "advanced": false,
                            "preview": false,
                            "keepOpen": true,
                            "schemaProperty": "company_profile_online_profile_types"
                        },
                        {
                            "id": "ONLINE_PLATFORMS",
                            "label": "Online Platforms",
                            "filterType": "DROP_DOWN",
                            "advanced": true,
                            "preview": false,
                            "keepOpen": true,
                            "schemaProperty": "company_profile_online_profiles"
                        },
                        {
                            "id": "ONLINE_PLATFORM_SEARCH",
                            "label": "Online Platform Search",
                            "filterType": "CONTAINS",
                            "advanced": true,
                            "preview": false,
                            "schemaProperty": "company_profile_online_profiles"
                        }
                    ]
                },
                {
                    "key": "IDENTIFIERS",
                    "label": "Identifiers",
                    "filters": [
                        {
                            "id": "COMPANY_ID",
                            "label": "Company Id",
                            "filterType": "CONTAINS",
                            "advanced": false,
                            "preview": false,
                            "defaultDisplayMode": "Hidden",
                            "schemaProperty": "company_id"
                        },
                        {
                            "id": "COMPANY_IDENTITY",
                            "label": "Company Identity",
                            "filterType": "CONTAINS",
                            "advanced": false,
                            "preview": false,
                            "schemaProperty": "company_identity"
                        },
                        {
                            "id": "CONTACT_ID",
                            "label": "Contact Id",
                            "filterType": "CONTAINS",
                            "advanced": false,
                            "preview": false,
                            "defaultDisplayMode": "Hidden",
                            "schemaProperty": "contact_id"
                        },
                        {
                            "id": "CONTACT_IDENTITY",
                            "label": "Contact Identity",
                            "filterType": "CONTAINS",
                            "advanced": false,
                            "preview": false,
                            "schemaProperty": "contact_identity"
                        },
                        {
                            "id": "BUILDER_ID",
                            "label": "Builder Id",
                            "filterType": "CONTAINS",
                            "advanced": false,
                            "preview": false,
                            "defaultDisplayMode": "Hidden",
                            "infoText": "Restricted to subscribers of the Buildertrend Builder Universe",
                            "schemaProperty": "company_bt_builder_ids"
                        }
                    ]
                }
            ]
        },
        {
            "key": "SCALE",
            "label": "Scale",
            "subgroups": [
                {
                    "key": "SIZE_&_MATURITY",
                    "label": "Size & Maturity",
                    "filters": [
                        {
                            "id": "EMPLOYEES",
                            "label": "Employees",
                            "filterType": "DROP_DOWN",
                            "advanced": false,
                            "preview": false,
                            "keepOpen": true,
                            "sortMode": "idPrefix",
                            "schemaProperty": "company_stat_employees_range"
                        },
                        {
                            "id": "YEARS_IN_BUSINESS",
                            "label": "Years in Business",
                            "filterType": "DROP_DOWN",
                            "advanced": false,
                            "preview": false,
                            "keepOpen": true,
                            "sortMode": "idPrefix",
                            "schemaProperty": "company_fact_years_in_business_range"
                        },
                        {
                            "id": "SALES",
                            "label": "Sales",
                            "filterType": "DROP_DOWN",
                            "advanced": true,
                            "preview": false,
                            "keepOpen": true,
                            "sortMode": "idPrefix",
                            "insight": {
                                "title": "INSIGHT - How it Works",
                                "text": "Sales data is inferred from indirect indicators of commercial activity and scale, or provided by third parties. It does not represent reported revenue. These signals may be incomplete or imprecise."
                            },
                            "infoText": "Revenue estimates are modeled and may not be accurate.",
                            "schemaProperty": "company_stat_sales_range"
                        }
                    ]
                },
                {
                    "key": "ORGANIZATIONAL_FOOTPRINT",
                    "label": "Organizational Footprint",
                    "filters": [
                        {
                            "id": "SCALE_RESIDENTIAL_DELIVERY_INDICATOR",
                            "label": "Residential Delivery Indicator",
                            "filterType": "DROP_DOWN",
                            "advanced": false,
                            "preview": false,
                            "keepOpen": true,
                            "schemaProperty": "company_address_rdi"
                        },
                        {
                            "id": "MULTIPLE_LOCATIONS",
                            "label": "Multiple Locations",
                            "filterType": "HAS_VALUE",
                            "advanced": false,
                            "preview": false,
                            "schemaProperty": "DO NOT INCLUDE IN RELEASE INITIAL RELEASE"
                        },
                        // {
                        //     "id": "NUMBER_OF_LOCATIONS",
                        //     "label": "Number of Locations",
                        //     "filterType": "DROP_DOWN",
                        //     "advanced": false,
                        //     "preview": false,
                        //     "schemaProperty": "DO NOT INCLUDE IN RELEASE INITIAL RELEASE"
                        // },
                        {
                            "id": "NUMBER_OF_OPERATING_STATES",
                            "label": "Number of Operating States",
                            "filterType": "CONTAINS",
                            "advanced": false,
                            "preview": false,
                            "infoText": "Operating states is based off of activity data (projects and permits), license data and other sources including descriptions of areas served",
                            "schemaProperty": "NEEDS TO BE DEVELOPED"
                        }
                    ]
                }
            ]
        },
        {
            "key": "SIGNALS",
            "label": "Signals",
            "subgroups": [
                {
                    "key": "DEFAULT",
                    "label": "",
                    "filters": [
                        {
                            "id": "RECENT_PERMIT_ACTIVITY",
                            "label": "Recent Permit Activity",
                            "filterType": "DROP_DOWN",
                            "advanced": false,
                            "preview": false,
                            "keepOpen": true,
                            "schemaProperty": "company_activity_recent_permit_activity"
                        },
                        {
                            "id": "PERMIT_TREND",
                            "label": "Permit Trend",
                            "filterType": "DROP_DOWN",
                            "advanced": false,
                            "preview": false,
                            "keepOpen": true,
                            "schemaProperty": "company_activity_permit_trend"
                        },
                        // {
                        //     "id": "EXPANSION_SIGNALS",
                        //     "label": "Expansion Signals",
                        //     "filterType": "HAS_VALUE",
                        //     "advanced": false,
                        //     "preview": false,
                        //     "insight": {
                        //         "title": "INSIGHT - How it Works",
                        //         "text": "Derived from multiple expansion related signals across organizational, geographic, commercial and demand-capture activity. Supporting signals are shown on individual records"
                        //     },
                        //     "schemaProperty": "NEEDS TO BE DEVELOPED"
                        // },
                        {
                            "id": "PERMIT_VOLUME",
                            "label": "Permit Volume",
                            "filterType": "DROP_DOWN",
                            "advanced": true,
                            "preview": false,
                            "keepOpen": true,
                            "schemaProperty": "company_permit_cnt_range"
                        }
                    ]
                }
            ]
        },
        {
            "key": "COMPLIANCE",
            "label": "Compliance",
            "subgroups": [
                {
                    "key": "DEFAULT",
                    "label": "",
                    "filters": [
                        {
                            "id": "LICENSE_TYPE",
                            "label": "License Type",
                            "filterType": "DROP_DOWN",
                            "advanced": false,
                            "preview": false,
                            "keepOpen": true,
                            "schemaProperty": "company_license_types_mapped"
                        },
                        {
                            "id": "LICENSE_COUNT",
                            "label": "License Count",
                            "filterType": "CONTAINS",
                            "advanced": false,
                            "preview": false,
                            "infoText": "The number of licenses associated to a contractor",
                            "schemaProperty": "company_license_cnt"
                        },
                        {
                            "id": "COMPLIANCE_ACTIVE_LICENSES_ONLY",
                            "label": "Active Licenses Only",
                            "filterType": "HAS_VALUE",
                            "operatorOverride": "gte",
                            "valuesOverride": ["1"],
                            "advanced": false,
                            "preview": false,
                            "insight": {
                                "title": "INSIGHT - How it Works",
                                "text": "We track active and inactive licenses for our contractors. By default we do not limit based on the status of the license. This option will ensure only contractors with active licenses are included if a selection is made above."
                            },
                            "schemaProperty": "company_license_active_license_cnt"
                        },
                        {
                            "id": "BONDED",
                            "label": "Bonded",
                            "filterType": "HAS_VALUE",
                            "advanced": true,
                            "preview": false,
                            "schemaProperty": "company_ind_indicators_formatted",
                            "operatorOverride": "contains",
                            "valuesOverride": ["Bonded"]
                        },
                        {
                            "id": "INSURED",
                            "label": "Insured",
                            "filterType": "HAS_VALUE",
                            "advanced": true,
                            "preview": false,
                            "insight": {
                                "title": "INSIGHT - How it Works",
                                "text": "Bonded and Insured indicators are based on limited available data and third-party signals. Coverage status may be incomplete, outdated or unavailable for many contractors and should not be considered definitive."
                            },
                            "schemaProperty": "company_ind_indicators_formatted",
                            "operatorOverride": "contains",
                            "valuesOverride": ["Insured"]
                        }
                    ]
                }
            ]
        },
        {
            "key": "CONTACTS",
            "label": "Contacts",
            "subgroups": [
                {
                    "key": "DEFAULT",
                    "label": "",
                    "filters": [
                        {
                            "id": "HAS_CONTACT",
                            "label": "Has Contact",
                            "filterType": "HAS_VALUE",
                            "advanced": false,
                            "preview": false,
                            "insight": {
                                "title": "INSIGHT - How it Works",
                                "text": "Not all contractor companies have individual contacts associated to them. Some may only have reachability data, such as phone or email, available at the company level."
                            },
                            "schemaProperty": "company_contact_has_primary_contact"
                        },
                        // {
                        //     "id": "ROLE",
                        //     "label": "Role",
                        //     "filterType": "DROP_DOWN",
                        //     "advanced": false,
                        //     "preview": false,
                        //     "schemaProperty": "DO NOT INCLUDE IN RELEASE INITIAL RELEASE"
                        // },
                        {
                            "id": "DECISION_MAKER",
                            "label": "Decision Maker",
                            "filterType": "DROP_DOWN",
                            "advanced": false,
                            "preview": false,
                            "keepOpen": true,
                            "schemaProperty": "contact_decision_maker"
                        },
                        {
                            "id": "CONTACTS_HAS_PHONE",
                            "label": "Has Phone",
                            "filterType": "HAS_VALUE",
                            "advanced": false,
                            "preview": false,
                            "schemaProperty": "contact_has_phone"
                        },
                        {
                            "id": "CONTACTS_HAS_EMAIL",
                            "label": "Has Email",
                            "filterType": "HAS_VALUE",
                            "advanced": false,
                            "preview": false,
                            "schemaProperty": "contact_has_email"
                        },
                        {
                            "id": "CONTACTS_EMAIL_VERIFIED",
                            "label": "Email Verified",
                            "filterType": "HAS_VALUE",
                            "advanced": false,
                            "preview": false,
                            "insight": {
                                "title": "INSIGHT - How it Works",
                                "text": "Email verification is performed by 3rd party services."
                            },
                            "schemaProperty": "contact_email_status"
                        },
                        {
                            "id": "TITLE_SEARCH",
                            "label": "Title Search",
                            "filterType": "CONTAINS",
                            "advanced": true,
                            "preview": false,
                            "infoText": "Free Form Text Search of Titles associated to contacts",
                            "schemaProperty": "contact_title"
                        }
                    ]
                }
            ]
        },
        {
            "key": "DISCOVER",
            "label": "Discover",
            "subgroups": [
                {
                    "key": "DEFAULT",
                    "label": "",
                    "filters": [
                        {
                            "id": "SEARCH_TERM_HIT_ENTER_TO_ADD_MULTIPLE",
                            "label": "",
                            "placeholder": "e.g. kitchen remodel",
                            "filterType": "CONTAINS",
                            "advanced": false,
                            "preview": false,
                            "schemaProperty": "search_text",
                            "schemaCube": "TBDContractorUniverseSearchIndex"
                        },
                        {
                            "id": "REVIEWS",
                            "label": "Reviews",
                            "filterType": "HAS_VALUE",
                            "advanced": false,
                            "preview": false,
                            "schemaProperty": "search_type",
                            "schemaCube": "TBDContractorUniverseSearchIndex",
                            "filterValue": "review"
                        },
                        {
                            "id": "WEBSITES",
                            "label": "Websites",
                            "filterType": "HAS_VALUE",
                            "advanced": false,
                            "preview": false,
                            "schemaProperty": "search_type",
                            "schemaCube": "TBDContractorUniverseSearchIndex",
                            "filterValue": "website"
                        },
                        {
                            "id": "LICENSES",
                            "label": "Licenses",
                            "filterType": "HAS_VALUE",
                            "advanced": false,
                            "preview": false,
                            "schemaProperty": "search_type",
                            "schemaCube": "TBDContractorUniverseSearchIndex",
                            "filterValue": "license"
                        },
                        {
                            "id": "PERMITS",
                            "label": "Permits",
                            "filterType": "HAS_VALUE",
                            "advanced": false,
                            "preview": false,
                            "schemaProperty": "search_type",
                            "schemaCube": "TBDContractorUniverseSearchIndex",
                            "filterValue": "permit"
                        },
                        {
                            "id": "PROJECTS",
                            "label": "Projects",
                            "filterType": "HAS_VALUE",
                            "advanced": false,
                            "preview": false,
                            "schemaProperty": "search_type",
                            "schemaCube": "TBDContractorUniverseSearchIndex",
                            "filterValue": "project"
                        }
                    ]
                }
            ]
        },
        {
            "key": "SOURCES",
            "label": "Sources",
            "subgroups": [
                {
                    "key": "DEFAULT",
                    "label": "",
                    "filters": [
                        {
                            "id": "SOURCE_TYPES",
                            "label": "Source Types",
                            "filterType": "DROP_DOWN",
                            "advanced": false,
                            "preview": false,
                            "keepOpen": true,
                            "schemaProperty": "company_source_types"
                        },
                        {
                            "id": "LAST_TOUCHED",
                            "label": "Last Touched",
                            "filterType": "DATE",
                            "advanced": false,
                            "preview": false,
                            "schemaProperty": "company_source_last_touch"
                        },
                        {
                            "id": "VERIFIED_RECORDS",
                            "label": "Verified Records",
                            "filterType": "HAS_VALUE",
                            "advanced": true,
                            "preview": false,
                            "schemaProperty": "NEEDS TO BE DEVELOPED"
                        },
                        {
                            "id": "COMPANY_VERIFIED",
                            "label": "Company Verified",
                            "filterType": "HAS_VALUE",
                            "advanced": true,
                            "preview": false,
                            "schemaProperty": "NEEDS TO BE DEVELOPED"
                        },
                        {
                            "id": "CONTACT_VERIFIED",
                            "label": "Contact Verified",
                            "filterType": "HAS_VALUE",
                            "advanced": true,
                            "preview": false,
                            "schemaProperty": "NEEDS TO BE DEVELOPED"
                        }
                    ]
                }
            ]
        },
        {
            "key": "LISTS",
            "label": "Lists",
            "subgroups": [
                {
                    "key": "DEFAULT",
                    "label": "",
                    "filters": [
                        {
                            "id": "CONTAINED_IN",
                            "label": "Contained In",
                            "filterType": "DROP_DOWN",
                            "operatorOverride": "contains",
                            "advanced": false,
                            "preview": false,
                            "insight": {
                                "title": "INSIGHT - How it Works",
                                "text": "Select a list you’ve saved or imported to include those contractors in your results. This allows you to build on prior work or focus on a known set of companies."
                            },
                            "schemaProperty": "company_contractor_lists",
                            "keepOpen": true
                        },
                        {
                            "id": "NOT_CONTAINED_IN",
                            "label": "Not Contained In",
                            "filterType": "DROP_DOWN",
                            "operatorOverride": "notContains",
                            "advanced": false,
                            "preview": false,
                            "insight": {
                                "title": "INSIGHT - How it Works",
                                "text": "Select a saved or imported list to exclude those contractors from your results. This is useful for removing previously reviewed or already contacted companies."
                            },
                            "schemaProperty": "company_contractor_lists",
                            "keepOpen": true
                        }
                    ]
                }
            ]
        }
    ]
};

const EXCLUDED_SCHEMA_PROPS = [
    "",
    "NEEDS TO BE DEVELOPED",
    "DO NOT INCLUDE IN RELEASE INITIAL RELEASE",
    "REFER TO EXISTING FUNCTIONALITY",
];

export const getActiveFilterConfig = (rawConfig) => {
    if (!rawConfig || !rawConfig.groups) return { groups: [] };

    return {
        ...rawConfig,
        groups: rawConfig.groups.map(group => {
            return {
                ...group,
                subgroups: group.subgroups.map(subgroup => {
                    return {
                        ...subgroup,
                        filters: (subgroup.filters || []).filter(filter => {
                            const prop = filter.schemaProperty?.trim();
                            return prop && !EXCLUDED_SCHEMA_PROPS.includes(prop);
                        })
                    };
                }).filter(subgroup => subgroup.filters.length > 0)
            };
        }).filter(group => group.subgroups.length > 0)
    };
};

export const CLEAN_FILTER_CONFIG = getActiveFilterConfig(FILTER_CONFIG);

// ---------------------------------------------------------------------------
// Product membership (tags)
//
// Single source of truth for which products expose which filter groups. Tag each
// group with the product keys it belongs to. A group not listed here defaults to
// ALL products (backward-safe). Both the org-side Explore UI and the admin
// per-org filter editor derive their group set from these tags, so the two can
// never drift.
// ---------------------------------------------------------------------------
export const GROUP_PRODUCT_TAGS = {
    PROFILE:    ['contractor_universe', 'business_universe'],
    TRADES:     ['contractor_universe', 'business_universe'],
    SERVICES:   ['contractor_universe'],
    TERRITORY:  ['contractor_universe'],
    SCALE:      ['contractor_universe'],
    SIGNALS:    ['contractor_universe'],
    COMPLIANCE: ['contractor_universe'],
    CONTACTS:   ['contractor_universe'],
    DISCOVER:   ['contractor_universe'],
    SOURCES:    ['contractor_universe'],
    LISTS:      ['contractor_universe'],
};

// Does a group belong to a product? Untagged groups belong to every product.
const groupBelongsToProduct = (groupKey, productKey) => {
    const tags = GROUP_PRODUCT_TAGS[groupKey];
    if (!tags) return true;
    return tags.includes(productKey);
};

// CLEAN_FILTER_CONFIG narrowed to the groups a single product exposes.
export const getFilterConfigForProduct = (productKey) => {
    if (!productKey) return CLEAN_FILTER_CONFIG;
    return {
        ...CLEAN_FILTER_CONFIG,
        groups: CLEAN_FILTER_CONFIG.groups.filter(g => groupBelongsToProduct(g.key, productKey)),
    };
};

// Set of group keys a product exposes (drives both rendering and admin editing).
export const getGroupKeysForProduct = (productKey) =>
    new Set(getFilterConfigForProduct(productKey).groups.map(g => g.key));

// Every filter that declares a `defaultDisplayMode` (e.g. COMPANY_ID/CONTACT_ID/
// BUILDER_ID default to Hidden), expressed as {FILTER_ID, DISPLAY_MODE} entries
// in the same shape as an org's saved per-product `filters` override list. Used
// to seed a new/edited org's subscription with explicit entries for these
// defaults on save, so they persist the same way a manually-changed dropdown
// does instead of only applying as a client-side fallback at render time.
export const getDefaultDisplayModeFilters = (productKey) => {
    const entries = [];
    getFilterConfigForProduct(productKey).groups.forEach(group => {
        group.subgroups.forEach(subgroup => {
            (subgroup.filters || []).forEach(f => {
                if (f.defaultDisplayMode) {
                    entries.push({
                        FILTER_ID: `${group.key}_${subgroup.key}_${f.id}`,
                        DISPLAY_MODE: f.defaultDisplayMode,
                    });
                }
            });
        });
    });
    return entries;
};
